// surveySteps.js
// Declarative question config for the survey demo. SurveyDemo renders
// one step at a time based on `type`.
export const surveySteps = [
  {
    id: 'overall',
    type: 'nps',
    prompt: 'How likely are you to recommend us to a friend or colleague?',
    min: 0,
    max: 10,
    minLabel: 'Not likely',
    maxLabel: 'Very likely',
  },
  {
    id: 'product',
    type: 'likert',
    prompt: 'How would you rate the quality of your product?',
    min: 1,
    max: 5,
    minLabel: 'Poor',
    maxLabel: 'Excellent',
  },
  {
    id: 'service',
    type: 'stars',
    prompt: 'How would you rate our customer service?',
    max: 5,
  },
  {
    id: 'feedback',
    type: 'open',
    prompt: "Anything else you'd like us to know?",
  },
];
